import { Controller } from "@hotwired/stimulus";

/**
 * Keeps a derived hidden field in sync with related toggle controls.
 * When any source toggle changes, the derived value is "1" if any source is
 * checked, "0" otherwise.
 */
export default class extends Controller {
  static targets = ["global", "list"];

  declare globalTarget: HTMLInputElement;
  declare listTargets: HTMLInputElement[];
  declare hasGlobalTarget: boolean;

  connect(): void {
    this.syncGlobalFromLists();
  }

  /** Called by the change action on each source toggle control. */
  listChanged(): void {
    this.syncGlobalFromLists();
  }

  private syncGlobalFromLists(): void {
    if (!this.hasGlobalTarget) return;
    if (this.listTargets.length === 0) return;

    const anyListChecked = this.listTargets.some((input) => input.checked);
    this.globalTarget.value = anyListChecked ? "1" : "0";
  }
}
